/** Open the API Settings modal from anywhere (Header listens for this event). */
export const openApiSettings = () => window.dispatchEvent(new Event('open-api-settings'));
